<template>
    <div class="container box-like">
        <div class="table-select">
            <a-menu :default-selected-keys="['columns']" mode="inline" @click="onSelectTable">
                <a-menu-item key="columns">订单信息</a-menu-item>
                <a-menu-item key="columnsA">液化气销售情况</a-menu-item>
                <!-- <a-menu-item key="columnsB">钢瓶进出库情况</a-menu-item> -->
                <a-menu-item key="columnsC1">欠款情况</a-menu-item>
                <a-menu-item key="columnsC2">还款情况</a-menu-item>
                <a-menu-item key="columnsD">汇总数据</a-menu-item>
            </a-menu>
        </div>
        <div class="table-content">
            <div class="button-box">
                <a-space>
                    <a-button icon="export" @click="onExportOrder" v-if="selectedTable === 'columns'">导出数据</a-button>
                    <a-button icon="export" @click="onExportDaily" v-if="selectedTable === 'columnsA'">销售日报导出</a-button>
                    <a-range-picker value-format="YYYY-MM-DD" @change="onInit" v-model="selectedDate"/>
                </a-space>
                <div>
                    <a-button icon="retweet" @click="onFilterAllReset">重置所有筛选条件</a-button>
                </div>
            </div>
            <!-- scroll: 页面太小的时候会让表格至少有相应的长度，如果表格项很少就去掉这个，表格项太多的话适当增加 -->
            <a-table :data-source="tableData" :columns="getColumns" :rowKey="(rec) => rec.indent_details_id || rec.id" :scroll="{ x: 1200, y: 55 * 10 }"
                :pagination="pageConfig">
                <!-- slot对应配置文件中customRender的内容 -->
                <div slot="filterDropdown" slot-scope="{ confirm, column }" style="padding: 8px">
                    <a-input class="filter-input" :placeholder="`搜索${column.title}`" v-model="filterItems[column.filterIndex]"
                        v-if="column.type === 'input'" />
                    <a-auto-complete class="filter-input" :placeholder="`请输入${column.title}`" v-model="filterItems[column.filterIndex]"
                        :data-source="column.items" @search="onAutoSearch" v-if="column.type === 'auto-input'" />
                    <a-select class="filter-select" :placeholder="`请选择${column.title}`" :mode="column.multi ? 'multiple' : ''"
                        v-model="filterItems[column.filterIndex]" v-if="column.type === 'select'">
                        <a-select-option :value="item.id" v-for="(item, index) in column.items" :key="index">{{item.name}}</a-select-option>
                    </a-select>
                    <div>
                        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                            @click="onFilterSearch(confirm)">搜索</a-button>
                        <a-button size="small" icon="retweet" style="width: 90px" @click="onFilterReset(column.filterIndex, confirm)">重置</a-button>
                    </div>
                </div>
                <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
            </a-table>
            <div class="statistic">
                <a-statistic :title="item.name" :value="item.value" style="margin-right: 50px" v-for="(item, index) in statistic"
                    :key="index">
                    <template slot="suffix">
                        <div>{{item.unit}}</div>
                    </template>
                </a-statistic>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState,
    mapMutations
} from 'vuex'
import {
    stationMap,
    payment
} from '@/common/project-config'
import {
    columns,
    columnsA,
    // columnsB,
    columnsC,
    columnsD
} from './statistic.conf.js'

export default {
    name: 'statistic',
    computed: {
        ...mapState('stored', ['userInfo']),
        // eslint-disable-next-line object-shorthand
        getColumns: function() {
            return this[this.selectedTable]
        }
    },
    data() {
        return {
            // 当前选中的id，只有编辑的时候需要，新增时改为-1
            selectedId: -1,
            // 表格数据
            tableData: [],
            // 显示编辑内容
            showModal: false,
            // 筛选内容
            filterItems: {},
            // 表格配置，在配置文件里
            columns: [...columns],
            columnsA: [...columnsA],
            // columnsB: [...columnsB],
            columnsC1: [...columnsC],
            columnsC2: [...columnsC],
            columnsD: [...columnsD],
            // 选中表格类型
            selectedTable: 'columns',
            // 选中日期
            selectedDate: [],
            // 分页配置
            pageConfig: {
                current: 1,
                pageSize: 10,
                total: 0,
                pageSizeOptions: ['10', '20', '50', '100', '500'],
                showSizeChanger: true,
                onChange: (a, b) => {
                    this.pageConfig.current = a
                    this.pageConfig.pageSize = b
                    this.onInit()
                },
                onShowSizeChange: (a, b) => {
                    this.pageConfig.current = 1
                    this.pageConfig.pageSize = b
                    this.onInit()
                }
            },
            // 汇总数据
            statistic: []
        }
    },
    created() {

    },
    mounted() {
        this.initMap()
        this.onInit()
        this.onAutoSearch()
    },
    props: {

    },
    watch: {

    },
    methods: {
        ...mapMutations('global', ['setLoading']),
        onInit() {
            switch (this.selectedTable) {
            case 'columns':
                this.onInitColumns()
                break
            case 'columnsA':
                this.onInitColumnsA()
                break
            // case 'columnB':
            //     this.onInitColumnsB()
            //     break
            case 'columnsC1':
                this.onInitColumnsC(true)
                break
            case 'columnsC2':
                this.onInitColumnsC(false)
                break
            case 'columnsD':
                this.onInitColumnsD()
                break
            default:
                break
            }
        },
        async onInitColumns() {
            // 开始loading
            this.setLoading('页面加载中...')
            // 请求地址，在controller里面编辑
            let res = await this.$util.request(this.$ctrl.statistic.get, {
                time: this.selectedDate,
                page: this.pageConfig.current,
                limit: this.pageConfig.pageSize,
                ...this.filterItems,
                status: this.filterItems.status || this.userInfo.stationId,
            })
            // 如果需要对后端返回的值进行转换在这里转
            this.tableData = res.data.data.map((s) => {
                let _s = { ...s}
                _s.status = stationMap[_s.status]
                return _s
            })
            // 其它的逻辑写在这里
            this.statistic = [{
                name: '总数量',
                unit: '瓶',
                value: res.count.sumamount
            },
            {
                name: '总重量',
                unit: '千克',
                value: res.count.sumweight
            },
            {
                name: '总价',
                unit: '元',
                value: res.count.summoney
            }]
            this.pageConfig.total = res.data.total
            // 结束loading
            this.setLoading('')
        },
        async onInitColumnsA() {
            // 开始loading
            this.setLoading('页面加载中...')
            // 请求地址，在controller里面编辑
            let res = await this.$util.request(this.$ctrl.statistic.getA, {
                status: this.userInfo.stationId,
                time: this.selectedDate,
                page: this.pageConfig.current,
                limit: this.pageConfig.pageSize
            })
            let resTotal = await this.$util.request(this.$ctrl.statistic.getATotal, {
                status: this.userInfo.stationId,
                time: this.selectedDate
            })
            // 如果需要对后端返回的值进行转换在这里转
            this.tableData = res.data.data
            // 其它的逻辑写在这里
            this.statistic = [{
                name: '总数量',
                unit: '瓶',
                value: resTotal.amount
            },
            {
                name: '总重量',
                unit: '千克',
                value: resTotal.weight
            },
            {
                name: '总价',
                unit: '元',
                value: resTotal.money
            }]
            this.pageConfig.total = res.data.total
            // 结束loading
            this.setLoading('')
        },
        async onInitColumnsC(type) {
            // 开始loading
            this.setLoading('页面加载中...')
            // 请求地址，在controller里面编辑
            let url = type ? this.$ctrl.statistic.getC1 : this.$ctrl.statistic.getC2
            let res = await this.$util.request(url, {
                status: this.userInfo.stationId,
                time: this.selectedDate,
                page: this.pageConfig.current,
                limit: this.pageConfig.pageSize
            })
            let resTotal = await this.$util.request(this.$ctrl.statistic.getCTotal, {
                status: this.userInfo.stationId,
                time: this.selectedDate
            })
            // 如果需要对后端返回的值进行转换在这里转
            this.tableData = res.data.data
            // 其它的逻辑写在这里
            this.statistic = [{
                name: '欠款合计',
                unit: '元',
                value: resTotal.debtor
            },
            {
                name: '还款合计',
                unit: '元',
                value: resTotal.money
            }]
            this.pageConfig.total = res.data.total
            // 结束loading
            this.setLoading('')
        },
        async onInitColumnsD() {
            // 开始loading
            this.setLoading('页面加载中...')
            // 请求地址，在controller里面编辑
            let res = await this.$util.request(this.$ctrl.statistic.getD, {
                status: this.userInfo.stationId,
                time: this.selectedDate
            })
            // 如果需要对后端返回的值进行转换在这里转
            this.tableData = [
                {
                    name: '日销售量',
                    money: res.rcount
                },
                {
                    name: '日销金额',
                    money: res.rmoney
                },
                {
                    name: '实收金额',
                    money: res.rsjmoney
                },
                {
                    name: '实收液化气金额',
                    money: res.rsjyhqmoney
                }
            ]
            // 其它的逻辑写在这里
            this.statistic = []
            this.pageConfig.total = 1
            // 结束loading
            this.setLoading('')
        },
        async initMap() {
            // 一般情况下，这里写的是选择型的筛选条件的选项，从后端获取
            let res, index
            // 区域管理
            // res = await this.$util.request(this.$ctrl.area.get, {
            //     status: this.userInfo.stationId,
            // })
            // this.formModel.arae_id.items = res.data.data
            // 客户类型
            res = await this.$util.request(this.$ctrl.guest_type.get, {
                status: this.userInfo.stationId,
                limit: 9999
            })
            index = this.columns.findIndex((s) => s.filterIndex === 'ctyid')
            this.columns[index].items = res.data.data
            // 商品类型
            res = await this.$util.request(this.$ctrl.goods.get, {
                status: this.userInfo.stationId,
                is_two: 2,
                limit: 9999
            })
            index = this.columns.findIndex((s) => s.filterIndex === 'goodsname')
            this.columns[index].items = res.data.data.map((s) => ({
                id: s.name,
                name: s.name
            }))
            // 商品规格
            res = await this.$util.request(this.$ctrl.goods.getByGroup, {
                status: this.userInfo.stationId,
                limit: 9999
            })
            index = this.columns.findIndex((s) => s.filterIndex === 'specification')
            this.columns[index].items = res.data.data.map((s) => ({
                id: s.specification,
                name: s.specification
            }))
            // 支付方式
            index = this.columns.findIndex((s) => s.filterIndex === 'pay')
            this.columns[index].items = Object.entries(payment).reduce((p, [k, v]) => [
                ...p, {
                    id: k,
                    name: v
                }
            ], [])
        },
        onSelectTable(e) {
            this.selectedTable = e.key
            this.pageConfig.current = 1
            this.onInit()
        },
        onAutoSearch(e) {
            this.$util.request(this.$ctrl.guest_source.get, {
                status: this.userInfo.stationId,
                is_two: 2,
                name: e,
                limit: 9999
            }).then((res) => {
                let index = this.columns.findIndex((s) => s.filterIndex === 'cli_id')
                this.columns[index].items = res.data.data.map((s) => s.name)
            })
        },
        onFilterSearch(confirm) {
            this.pageConfig.current = 1
            this.onInit()
            confirm()
        },
        onFilterReset(key, confirm) {
            if (this.filterItems.hasOwnProperty(key)) {
                this.filterItems[key] = undefined
                this.pageConfig.current = 1
                this.onInit()
                confirm()
            }
        },
        onFilterAllReset() {
            Object.keys(this.filterItems).forEach((k) => {
                this.filterItems[k] = undefined
            })
            this.pageConfig.current = 1
            this.onInit()
        },
        onExportOrder() {
            window.open(
                `http://xm.lcxxjs.cn/api/export?status=${this.userInfo.stationId}&time=${JSON.stringify(this.selectedDate)}&${Object.entries(this.filterItems).map(([k, v]) => {
                    if (v) {
                        return `${k}=${v}`
                    }
                }).join('&')}`
            )
        },
        onExportDaily() {
            window.open(
                `http://xm.lcxxjs.cn/api/xsdc?status=${this.userInfo.stationId}&time=${JSON.stringify(this.selectedDate)}&${Object.entries(this.filterItems).map(([k, v]) => {
                    if (v) {
                        return `${k}=${v}`
                    }
                }).join('&')}`
            )
        }
    }
}
</script>

<style scoped lang="less">
    @import './statistic.less';
</style>
